import { ErrorResponse, SuccessResponse } from './types'

export const error = <T>(error: T): ErrorResponse<T> => ({ error })
export const success = (): SuccessResponse => ({ isSuccess: true })
